
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $cJntk = parcelRequire("cJntk");

var $bmHVE = parcelRequire("bmHVE");

var $c3RIb = parcelRequire("c3RIb");

var $9vPkX = parcelRequire("9vPkX");

var $dIG9p = parcelRequire("dIG9p");

var $lrKvI = parcelRequire("lrKvI");

var $jzydl = parcelRequire("jzydl");

var $inIMS = parcelRequire("inIMS");

var $5DwXE = parcelRequire("5DwXE");

var $bnthu = parcelRequire("bnthu");

var $bdrRp = parcelRequire("bdrRp");

var $bV0pP = parcelRequire("bV0pP");
const $78427abdc98d4bbd$var$icon1Feature = new (0, $dIG9p.default)({
    geometry: new (0, $9vPkX.default)([
        700000,
        200000
    ])
});
$78427abdc98d4bbd$var$icon1Feature.setStyle(new (0, $c3RIb.default)({
    image: new (0, $bmHVE.default)(/** @type {olx.style.IconOptions} */ {
        anchor: [
            0.5,
            1
        ],
        src: "data/icon.png"
    }),
    text: new (0, $cJntk.default)({
        text: "Icon with anchor on the bottom center",
        stroke: new (0, $lrKvI.default)({
            color: "black",
            width: 3
        }),
        fill: new (0, $inIMS.default)({
            color: "white"
        })
    })
}));
const $78427abdc98d4bbd$var$icon2Feature = new (0, $dIG9p.default)({
    geometry: new (0, $9vPkX.default)([
        1000000,
        200000
    ])
});
$78427abdc98d4bbd$var$icon2Feature.setStyle(new (0, $c3RIb.default)({
    image: new (0, $bmHVE.default)(/** @type {olx.style.IconOptions} */ {
        src: "data/image-static.png"
    }),
    text: new (0, $cJntk.default)({
        text: "Default positioning",
        stroke: new (0, $lrKvI.default)({
            color: "black",
            width: 3
        }),
        fill: new (0, $inIMS.default)({
            color: "white"
        })
    })
}));
const $78427abdc98d4bbd$var$vectorSource = new (0, $bnthu.default)({
    features: [
        $78427abdc98d4bbd$var$icon1Feature,
        $78427abdc98d4bbd$var$icon2Feature
    ]
});
const $78427abdc98d4bbd$var$vectorLayer = new (0, $bdrRp.default)({
    source: $78427abdc98d4bbd$var$vectorSource
});
const $78427abdc98d4bbd$var$map = new (0, $5DwXE.default)({
    interactions: (0, $jzydl.defaults)(),
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        }),
        $78427abdc98d4bbd$var$vectorLayer
    ],
    target: "map2d",
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    view: new (0, $9DiKA.default)({
        center: [
            850000,
            200000
        ],
        zoom: 7
    })
});
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $78427abdc98d4bbd$var$ol3d = new (0, $cc3xD.default)({
    map: $78427abdc98d4bbd$var$map,
    target: "map3d"
});
const $78427abdc98d4bbd$var$scene = $78427abdc98d4bbd$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$78427abdc98d4bbd$var$scene.terrainProvider = tp);
$78427abdc98d4bbd$var$ol3d.setEnabled(true);
window["toggleClampToGround"] = function() {
    let altitudeMode;
    if (!$78427abdc98d4bbd$var$vectorLayer.get("altitudeMode")) altitudeMode = "clampToGround";
    $78427abdc98d4bbd$var$vectorLayer.set("altitudeMode", altitudeMode);
    $78427abdc98d4bbd$var$map.removeLayer($78427abdc98d4bbd$var$vectorLayer);
    $78427abdc98d4bbd$var$map.addLayer($78427abdc98d4bbd$var$vectorLayer);
};
window["ol3d"] = $78427abdc98d4bbd$var$ol3d;
window["scene"] = $78427abdc98d4bbd$var$scene;
document.getElementById("enable").addEventListener("click", ()=>$78427abdc98d4bbd$var$ol3d.setEnabled(!$78427abdc98d4bbd$var$ol3d.getEnabled()));
$78427abdc98d4bbd$var$ol3d.enableAutoRenderLoop();
// Tilt camera
const $78427abdc98d4bbd$var$camera = $78427abdc98d4bbd$var$scene.camera;
const $78427abdc98d4bbd$var$pivot = (0, $cc3xD.pickBottomPoint)($78427abdc98d4bbd$var$scene);
if ($78427abdc98d4bbd$var$pivot) {
    const options = {};
    const transform = Cesium.Matrix4.fromTranslation($78427abdc98d4bbd$var$pivot);
    const axis = $78427abdc98d4bbd$var$camera.right;
    (0, $cc3xD.rotateAroundAxis)($78427abdc98d4bbd$var$camera, -Math.PI / 4, axis, transform, options);
}


//# sourceMappingURL=icon-position.2327b5f9.js.map
